import {Component, Input, OnInit} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {EntryGroupService} from '@app/product/services/entry-group.service';
import {DcpConfigService} from '@app/services/dcp-config.service';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {DcpEntryGroup, FeatureTogglesService} from '@dcp/configurator';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Cart} from '@spartacus/cart/base/root';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {Observable, combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {ContractPriceService} from '../services/contract-price.service';

@UntilDestroy()
@Component({
  selector: 'dcp-group-total',
  templateUrl: './group-total.component.html',
  styleUrls: ['./group-total.component.scss']
})
export class GroupTotalComponent implements OnInit {
  @Input() providerContract: DcpEntryGroup;
  @Input() showDivider: boolean = true;
  /** Can be order or cart object. It needs to contain data.priceTotalsByContract */
  @Input() checkout$: Observable<Cart>;
  shouldShowGroupTotal$: Observable<boolean>;
  groupTotal$: Observable<string>;
  // Set to the PRODUCT of the entryGroup
  entry: OrderEntry;
  isCps: boolean;

  constructor(
    private contractPriceService: ContractPriceService,
    private entryGroupService: EntryGroupService,
    private dcpConfigService: DcpConfigService,
    private featureToggleService: FeatureTogglesService,
    public dcpOrderEntryService: DcpOrderEntryService
  ) {
  }

  ngOnInit() {
    this.entry = this.entryGroupService.getFirstEntry(this.providerContract.entryGroups);
    this.isCps = this.entry?.product?.configurable;
    this.setShouldShowGroupTotal(this.entry);
    if (this.isCps) {
      this.groupTotal$ = this.contractPriceService.getSplitGroupTotal('all', this.entry, this.checkout$);
    } else if (this.entry) {
      this.groupTotal$ = this.contractPriceService.getGroupTotal(this.providerContract?.entryGroups, this.checkout$);
    }
  }

  setShouldShowGroupTotal(entry: OrderEntry) {
    const currentBundleTemplate = this.dcpOrderEntryService.getBundleTemplate(entry);
    this.shouldShowGroupTotal$ =
      combineLatest([
        this.featureToggleService.isEnabled(UNLEASH_TOGGLES.showGroupTotal),
        this.dcpConfigService.getCommercialModelConfig(entry.product, entry.transactionType, currentBundleTemplate)
      ]).pipe(map(([toggle, config]) => (toggle || !this.isCps) && config.showGroupTotal));
  }

  hasMultipleEntries(): boolean {
    if (!this.isCps) {
      return true;
    }
    const hasDerivative = this.entryGroupService.collectEntryGroups(
      this.entryGroupService.isDerivative, this.providerContract.entryGroups, []
    ).length > 0;
    return (this.providerContract.entryGroups?.length > 1 || hasDerivative);
  }
}
